import { useReceivedPaymentDetailContext } from "@pages/collectionAdministration/pages/ReceivedPaymentDetail/context/ReceivedPaymentDetailContext"
import { useState } from "react"

export const useReceivedPaymentDetail = () => {

    const { chargeInstanceDetailData } = useReceivedPaymentDetailContext()
    //exonerate|amount|extraordinary_payment|payment_comprobant

    const [isOpenReceivedPaymenteModal, setIsOpenReceivedPaymenteModal] = useState({
        name: null,
        isOpen: false,
        record: null
    })

    const handleOnOpenCloseModal = async ({ record, name, isOpen }) => {
        setIsOpenReceivedPaymenteModal(prev => ({
            ...prev,
            name,
            isOpen,
            record
        }))
    }

    return {
        isOpenReceivedPaymenteModal,
        chargeInstanceDetailData,
        handleOnOpenCloseModal,
    }
}